import React from "react";
import { PnmacUIButton } from 'pnmac-universal-components';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
export default function LogOutDialog(props) {
  var handleClose = function (logout) {
    props.close(logout);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dialog, {
    open: props.open,
    onClose: handleClose,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "alert-dialog-title"
  }, props.title), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, {
    id: "alert-dialog-description"
  }, props.message)), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(PnmacUIButton, {
    onClick: function () {
      return handleClose(false);
    },
    color: "primary",
    autoFocus: true
  }, props.keepMeLoggedIn), /*#__PURE__*/React.createElement(PnmacUIButton, {
    onClick: function () {
      return null;
    },
    color: "primary",
    autoFocus: true
  }, props.timer))));
}